import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as PlusIcon } from 'assets/icons/PlusIcon.svg';

import { Button } from 'components/_basic/Button/Button';

import { IButtonCreateProjectProps } from '../../types';

import styles from './CreateProjectButtonEmptyWS.module.scss';

export const CreateProjectButtonEmptyWS: FC<IButtonCreateProjectProps> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <Button
      className={styles.createProjectButton}
      variant="contained"
      color="primary"
      endIcon={<PlusIcon />}
      onClick={onClick}
    >
      {t('createProject')}
    </Button>
  );
};
